import type { DefinedInitialDataOptions } from '@tanstack/react-query';

export const UseQueryDefaultOptions = {
  throwOnError: true,
  retry: false,
  refetchOnWindowFocus: false,
  refetchInterval: false,
  refetchOnMount: false,
} as const satisfies Pick<
  DefinedInitialDataOptions,
  'throwOnError' | 'retry' | 'refetchOnWindowFocus' | 'refetchInterval' | 'refetchOnMount'
>;
